import { type HTMLAttributes, memo } from 'react'

import classNames from 'classnames'

import s from './PageContainer.module.scss'

export const PageContainer = memo(function PageContainer({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <main
            className={classNames(s.container, className)}
            {...props}
        />
    )
})
